import { Route, Routes } from "react-router-dom";

import CarUsage from "./pages/CarUsage";
import EuerDeclarationOverview from "./pages/EuerDeclarationOverview";
import OfficeUsage from "./pages/OfficeUsage";
import TravelExpenses from "./pages/TravelExpenses";

const EuerDeclaration = () => {
  return (
    <Routes>
      <Route path="/" element={<EuerDeclarationOverview />} />
      <Route path="/car-usage" element={<CarUsage />} />
      <Route path="/office-usage" element={<OfficeUsage />} />
      <Route path="/travel-expenses" element={<TravelExpenses />} />
    </Routes>
  );
};

export default EuerDeclaration;
